<div
  fxLayout="column"
  fxLayoutAlign="space-between"
>
  <div
    fxLayout="row"
    fxLayoutAlign="space-between"
    matTooltip="{{ alert.description }}"
    [matTooltipDisabled]="!alert?.description"
  >
    @if (alert?.referenceDocumentId) {
      <h3>
        <app-link-helper
          [documentId]="alert.referenceDocumentId"
          [labelTxt]="alert.title"
          [hideType]="true"
        ></app-link-helper>
      </h3>
    } @else {
      <h3
        [class.clickable]="hasLink"
        (click)="navigateToSref()"
      >
        <i
          class="mdi s24 mr-5"
          [class]="getClass(alert)"
        ></i>
        {{ alert?.title }}
      </h3>
    }
    @if (alert?.actions?.length) {
      <div
        fxLayout="row"
        fxLayoutAlign="center center"
        matTooltip="{{ action?.title }}"
      >
        @for (action of alert.actions; track $index; let i = $index) {
          @if (action.target !== 'post') {
            <a
              [href]="action.link"
              [target]="action.target"
            >
              <i
                class="mdi s24 secondary-text"
                [class]="'mdi-' + action.icon"
              ></i>
            </a>
          } @else if (canAct()) {
            <span (click)="postAction(action.link)">
              <i
                class="mdi s24 secondary-text"
                [class]="'mdi-' + action.icon"
              ></i>
            </span>
          }
        }
      </div>
    }
  </div>
  <div class="ph-24 pt-10">
    <div>
      {{ alert?.subTitle }}
      @if (alert?.kbLink) {
        <a
          [href]="alert.kbLink"
          target="_blank"
          matTooltip="Link to knowledge base article"
        >
          <i class="mdi s20 secondary-text mdi-help-circle"></i>
        </a>
      }
    </div>
    @if (alert?.percentComplete > 0) {
      <mat-progress-bar
        class="alerts-tab-progress"
        mode="determinate"
        [value]="alert.percentComplete * 100"
      ></mat-progress-bar>
    }
  </div>
</div>
